const getOrderLineModifiers4 = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine && indexOrderLine.Modifiers) {
      return typeof indexOrderLine.Modifiers === 'object'
        ? indexOrderLine.Modifiers[3] : indexOrderLine.Modifiers.slice(6, 8);
    }
    return null;
  }
  return orderLine
    ? orderLine.map(item => (typeof item.Modifiers === 'object'
      ? item.Modifiers[3] : item.Modifiers.slice(6, 8)).join(', '))
    : null;
};

export default getOrderLineModifiers4;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineModifiers4.js